import { render } from "./ItemManagement.vue?vue&type=template&id=afcb3a76&scoped=true"
import script from "./ItemManagement.vue?vue&type=script&lang=js"
export * from "./ItemManagement.vue?vue&type=script&lang=js"

import "./ItemManagement.vue?vue&type=style&index=0&id=afcb3a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcb3a76"]])

export default __exports__